<template>
  <v-list>
    <v-list-item
        v-for="(item, i) in data"
        :key="i"
    >
      <v-list-item-content>
        <v-list-item-title>
          {{ i+1 }}. {{ item.date_from }} &ndash; {{ item.date_to }}
          <v-btn
              class="ml-5"
              color="fontDefault white--text"
              @click="showDeleteModal(item)"
          >
            <v-icon>delete</v-icon>
          </v-btn>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import {mapActions} from 'vuex';

export default {
  name: "CompanyExemptionsList",
  props: {
    data: {Array, Boolean},
  },
  methods: {
    ...mapActions('setCompanyExemption', ["updateVisibleExemptionDeleteModal", "updateExemptionToDelete"]),
    showDeleteModal(item) {
      this.updateVisibleExemptionDeleteModal(true);
      this.updateExemptionToDelete(item.id);
    }
  }
}
</script>

<style scoped>

</style>